import Page from 'front/pages/Page/Page';
import Urls from 'django_js_front/reverse.js';
import * as _ from 'underscore';

import TopBar from 'front/components/Common/TopBar/TopBar';
import ClientItem from 'front/components/Common/ClientItem/ClientItem';

import {VIEWPORT_EVENTS} from '../../constants/Constants';
import './IllustrationsClients.less';

import * as Template from './IllustrationsClients.jinja';

const Selectors = {
    el: '.IllustrationsClients',
    categoryTitle: '.IllustrationsClients-categoryTitle',
    categoryList: '.IllustrationsClients-categoryList',
    topBarFilters: '.TopBar-filters',
    tobBarFilterItem: '.TopBar-filtersItem'
};

const BindFunctions = [
    'onItemClick',
    'onDropDown'
];


export default class IllustrationsClients extends Page {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.tobBarFilterItem}`]: this.onItemClick,
            [`${VIEWPORT_EVENTS.click} ${Selectors.categoryTitle}`]: this.onDropDown
        };
    }

    constructor(options = {}) {
        options.el = Selectors.el;
        options.VIEWS_TO_REGISTER = {
            'top-bar': {selector: '.TopBar', viewConstructor: TopBar},
            'client-item': {selector: '.ClientItem', viewConstructor: ClientItem}
        };
        options.template = Template;
        super(options);
        _.bindAll(this, BindFunctions);

        this.$(Selectors.tobBarFilterItem).eq(1)
            .addClass('active');
    }

    onItemClick(e) {
        const $target = $(e.currentTarget);

        if ($target.hasClass('active')) {
            e.preventDefault();
            window.location = Urls['front:illustrations']();
        }
    }

    onDropDown(e) {
        const $target = $(e.currentTarget).parent();
        const $currentCategory = $target.find('.IllustrationsClients-categoryList');
        const $currentItem = $currentCategory.find('.ClientItem');

        if ($currentCategory.hasClass('active')) {
            $currentCategory.removeClass('active');
            $currentItem.removeClass('active');
        } else {
            this.$('.IllustrationsClients-categoryList').removeClass('active');
            this.$('.ClientItem').removeClass('active');
            $currentItem.addClass('active');
            $currentCategory.addClass('active');

            $currentCategory.children().addClass('isHide');
            this.onResize();
        }
    }
}
